export default __webpack_public_path__ + "static/media/footer.cc6cda5a.svg";